<script setup lang="ts">
/***
 * template to partnergroup
 */
const props = defineProps<PaginatedDataTableCellProps>();
import { useI18n } from 'vue-i18n';

import type { PaginatedDataTableCellProps } from '@/components/paginated-datatable/templates/templateTypes';
import { ConnectedByV1Dto, type SimpleConnectV1Dto } from '@/openapi';
import { navigationItems } from '@/router/navigation';

const { t } = useI18n();
const groupsIcon = `${navigationItems?.find((a) => a.name === 'partnergroups')?.icon ?? 'mdi mdi-factory'} sey-icon mr-1`;
const contractIcon = `${navigationItems?.find((a) => a.name === 'contracts')?.icon ?? 'mdi mdi-file-document-edit-outline'} sey-icon mr-1`;
const connectionType = ConnectedByV1Dto['connectionType'];
</script>

<template>
  <div class="flex flex-col gap-2">
    <div v-for="arrayValue in props.cell as Array<SimpleConnectV1Dto>" :key="arrayValue.id">
      <div>
        <span :class="groupsIcon"> </span>
        <RouterLink class="a-inline" :to="`/partnergroups/${arrayValue.id}`">{{
          arrayValue.name
        }}</RouterLink>
      </div>
      <div v-for="connValue in arrayValue.connectedBy" :key="connValue.id">
        <div v-if="connValue.connectionType === connectionType['CONTRACT']">
          <span :class="contractIcon"> </span>
          <RouterLink class="a-inline" :to="`/contracts/${connValue.id}`">{{
            t('labels.connectedBy', { source: t('labels.contracts') })
          }}</RouterLink>
        </div>
      </div>
    </div>
  </div>
</template>
